// import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as languageActions } from "../../reducer/language";
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import { login } from "../../actions/auth";

import './login.styles.css'

const required = (value) => {
  if (!value) {
    return (
      <div className="login-alert" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login = (props) => {
  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Student');
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);
  const [usernameLabelShow, setUsernameLabelShow] = useState(1)
  const [passwordLabelShow, setPasswordLabelShow] = useState(1)

  const dispatch = useDispatch();

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const onChangeRole = (e) => {
    const role = e.target.value;
    console.log("role")
    setSelectedOption(role);
  }
  const onChangeLanguage = (e) => {
    const language = e.target.value;
    dispatch(languageActions.setLanguage(language));
  }
  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      dispatch(login(username, password, selectedOption))
        .then(() => {
          props.history.push("/home");
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  if (isLoggedIn) {
    return <Redirect to="/home" />;
  }

  return (
    <div className="form-signin">
      <div className="card card-container" id="formParent" tabIndex={0}>
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        <h1 className="title-font">Sign in with username and password</h1>

        <div style={{ marginTop: '1.5rem' }}>
          <Form onSubmit={handleLogin} ref={form}>
            {/* Username */}
            <div className="form-label-group">
            <Input
              type="text"
              name="username"
              className="form-control"
              value={username}
              id="usernameInput"
              placeholder="Username"
              onChange={onChangeUsername}
              validations={[required]}
            />
          </div>

          {/* Password */}
          <div className="form-label-group">
            <Input
              type="password"
              name="password"
              className="form-control"
              value={password}
              id="passwordInput"
              placeholder="Password"
              onChange={onChangePassword}
              validations={[required]}
            />
          </div>

          {/* Row 1 — Role */}
          <div className="radio-group">
            <Input
              type="radio"
              value="Student"
              name="role"
              id="Student"
              onChange={onChangeRole}
              checked={selectedOption === "Student"}
            />
            <label htmlFor="Student" className="login-label">Student</label>

            <Input
              type="radio"
              value="Instructor"
              name="role"
              id="Instructor"
              onChange={onChangeRole}
              checked={selectedOption === "Instructor"}
            />
            <label htmlFor="Instructor" className="login-label">Instructor</label>
          </div>

          {/* Row 2 — Language */}
          <div className="radio-row">
            <Input
              type="radio"
              value="R"
              name="language"
              id="R"
              onChange={onChangeLanguage}
              checked={selectedLanguage === "R"}
            />
            <label htmlFor="R" className="login-language">R</label>

            <Input
              type="radio"
              value="Python"
              name="language"
              id="Python"
              onChange={onChangeLanguage}
              checked={selectedLanguage === "Python"}
            />
            <label htmlFor="Python" className="login-language">Python</label>
          </div>

          {/* Login Button */}
          <div className="button-container">
            <button className="login-button" disabled={loading}>
              {loading && <span className="spinner-border spinner-border-sm"></span>}
              <span>Login</span>
            </button>
          </div>

          {/* Forgot Password */}
          <div className="text-end forgot-password">
            <Link to="/forgot" className="underline">Forgot password?</Link>
          </div>

          {/* Message */}
          {message && (
            <div className="form-group">
              <div className={!isLoggedIn ? "alert alert-danger" : ""} role="alert">
                {message}
              </div>
            </div>
          )}

          <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;